var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "live-box" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-xs-12" }, [
        _c("div", { staticClass: "live-box" }, [
          _c("img", {
            staticClass: "cover",
            attrs: {
              src: "//thumbnail-large.micoworld.net/" + _vm.profile.cover,
              "data-cover": _vm.profile.cover,
              onerror:
                "this.onerror=null;this.src='//image.micoworld.net/' + this.getAttribute('data-cover')",
              alt: "",
            },
          }),
          _vm._v(" "),
          _vm.isEnd
            ? _c("div", { staticClass: "end" }, [
                _c("img", {
                  staticClass: "avatar",
                  attrs: {
                    src:
                      "//thumbnail-small.micoworld.net/" + _vm.profile.avatar,
                    "data-cover": _vm.profile.avatar,
                    onerror:
                      "this.onerror=null;this.src='//image.micoworld.net/' + this.getAttribute('data-cover')",
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "nickname" }, [
                  _vm._v(_vm._s(_vm.profile.nickname)),
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "tip" }, [
                  _vm._v("This live has ended"),
                ]),
              ])
            : _c(
                "div",
                { staticClass: "video-box" },
                [
                  _vm.flvSupported
                    ? _c("flv", {
                        attrs: { profile: _vm.profile },
                        on: { end: _vm.endHandle },
                      })
                    : _c("video-js", {
                        attrs: { profile: _vm.profile },
                        on: { end: _vm.endHandle },
                      }),
                  _vm._v(" "),
                  _c("div", { staticClass: "profile" }, [
                    _c("img", {
                      staticClass: "avatar",
                      attrs: {
                        src:
                          "//thumbnail-small.micoworld.net/" +
                          _vm.profile.avatar,
                        "data-cover": _vm.profile.avatar,
                        onerror:
                          "this.onerror=null;this.src='//image.micoworld.net/' + this.getAttribute('data-cover')",
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "name_id" }, [
                      _c("div", { staticClass: "nickname" }, [
                        _vm._v(_vm._s(_vm.profile.nickname)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "id" }, [
                        _vm._v(_vm._s("Mico ID: " + _vm.profile.mico_id)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "chat_share" }, [
                    _c(
                      "div",
                      { staticClass: "chat", on: { click: _vm.chatHandle } },
                      [_vm._v("Invites you to chat")]
                    ),
                    _vm._v(" "),
                    _c("img", {
                      staticClass: "share",
                      attrs: {
                        src: "//image.micoworld.net/8fc22411aad96f092587745b52669def",
                      },
                      on: { click: _vm.chatHandle },
                    }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bubble-box download" }, [
                    _c("canvas", {
                      attrs: {
                        id: "canvas-bubble",
                        width: "36",
                        height: "300",
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "like-box",
                        on: { click: _vm.giftHandle },
                      },
                      [
                        _c("img", {
                          staticClass: "live-lucybag",
                          attrs: {
                            src: "//image.micoworld.net/dd62cba35e3027a83c95f5bbea2c07c8",
                            alt: "",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _vm._m(0),
                ],
                1
              ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticStyle: { display: "none" } }, [
      _c("img", {
        attrs: { id: "img1", src: "/img/share/like1.png", alt: "" },
      }),
      _vm._v(" "),
      _c("img", {
        attrs: { id: "img2", src: "/img/share/like2.png", alt: "" },
      }),
      _vm._v(" "),
      _c("img", {
        attrs: { id: "img3", src: "/img/share/like3.png", alt: "" },
      }),
      _vm._v(" "),
      _c("img", {
        attrs: { id: "img4", src: "/img/share/like4.png", alt: "" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }